import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f651e4ab-7ee9-48a6-ba28-4c2cc6db2347/artifacts/te5aqtnq_FullLogo_Transparent_NoBuffer.png";

export const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="Millennium Wellness Spa" 
              className="h-16 w-auto object-contain"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Professional massage therapy and preventative wellness care in Daytona Beach, FL.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-3">
              {["About", "Services", "Business Plan", "Testimonials"].map((item) => (
                <li key={item}>
                  <Link 
                    to={`/${item.toLowerCase().replace(' ', '-')}`}
                    className="text-slate-400 hover:text-white text-sm transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-[#D4AF37]" />
                <span>211 E. International Speedway Blvd # 114<br />Daytona Beach, FL 32118</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="flex-shrink-0 text-[#D4AF37]" />
                <span>386-286-4481</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="flex-shrink-0 text-[#D4AF37]" />
                <span>millenniumwellnessspa@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-semibold mb-4 text-[#D4AF37]">Business Hours</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center gap-3">
                <Clock size={16} className="flex-shrink-0 text-[#D4AF37]" />
                <div>
                  <p>Mon - Fri: 9am - 7pm</p>
                  <p>Sat: 10am - 5pm</p>
                  <p>Sun: By Appointment</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Millennium Wellness Spa. All rights reserved.
          </p>
          <p className="text-slate-500 text-sm">
            Lacresha Ramos, LMT - 16 Years of Excellence
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
